import {ModuleRouteManifest} from '../types'

export const adminRouteManifest: ModuleRouteManifest = {
  code: 'admin',
  privateRoutes: [
    'modellist/*',
    'methodlist/*',
    'rolemethodlist/*',
    'rolemodellist/*',
    'menulist/*',
    'menurole/*',
    'useraction/*',
    'culture/*',
    'translation/*',
    'applicationuser/*',
    'applicationrole/*',
    'applicationuserrole/*',
    'applicationuserclaim/*',
    'applicationroleclaim/*',
    'tenant/*',
    'code/*',
    'setting/*',
    'gender/*',
    'course/*',
    'organization/*',
    'semester/*',
    'semestercourse/*',
    'student/*',
  ],
}
